import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable, finalize, tap } from 'rxjs'
import { MessageService } from 'primeng/api'

import { ApiChannelSourcesService } from '../api/api-channel-sources.service'
import { IResponse } from '@data/interfaces/iresponseArray.interface'
import { IChannelSource } from '../../interfaces/channel-source.interface'

@Injectable({ providedIn: 'root' })
export class ChannelSourcesViewService {
  private sourcesSubject = new BehaviorSubject<IChannelSource[]>([])
  public sources$: Observable<IChannelSource[]> = this.sourcesSubject.asObservable()

  private loadingSubject = new BehaviorSubject<boolean>(false)
  public loading$: Observable<boolean> = this.loadingSubject.asObservable()

  //* cache local para lookup por key (lo usa ChannelBadgeComponent — labels del backend, no constants)
  private cache = new Map<string, IChannelSource>()

  constructor(private api: ApiChannelSourcesService, private messageService: MessageService) {}

  loadAll(page = 1, limit = 100, filters: any = {}): void {
    this.loadingSubject.next(true)
    this.api
      .getAll(page, limit, filters)
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe({
        next: (r) => {
          const list: IChannelSource[] = (r?.data as any)?.data ?? (r?.data as any) ?? []
          this.sourcesSubject.next(list)
          this.cache.clear()
          for (const s of list) this.cache.set(s.key, s)
        },
      })
  }

  getByKey(key: string): IChannelSource | null {
    return this.cache.get(key) ?? null
  }

  create(payload: any): Observable<IResponse> {
    return this.api.create(payload).pipe(tap((r) => this.afterWrite(r, 'Canal creado')))
  }

  update(id: string, payload: any): Observable<IResponse> {
    return this.api.update(id, payload).pipe(tap((r) => this.afterWrite(r, 'Canal actualizado')))
  }

  remove(id: string): Observable<IResponse> {
    return this.api.remove(id).pipe(tap((r) => this.afterWrite(r, 'Canal desactivado')))
  }

  private afterWrite(r: IResponse, summary: string): void {
    if (!r.error) {
      this.messageService.add({ severity: 'success', summary, detail: r.msg, life: 3000 })
      this.loadAll(1, 100)
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: r.msg, life: 4000 })
    }
  }
}
